<template>
  <PVDivider />
</template>

<script lang="ts">
export default {
  name: 'StandardDivider',
  compatConfig: { MODE: 3 },
};
</script>

<script setup lang="ts"></script>
